import { Component, OnInit, OnDestroy, DoCheck, ViewChild } from '@angular/core';
import { MapSearchService } from 'src/app/services/map-search.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { MapSearchCoordPointsFields, MapSearchNavAidsFields,FeatureType,
   getMapSearchCoordPointsFieldsKeyByValue, getMapSearchNavAidsFieldsKeyByValue,
    NavaidTypes, CoordinatePointTypes,
    getNavaidTypesKeyByValue, getCoordinatePointTypesKeyByValue } from 'src/app/models/EnumTypes';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { PointsService } from 'src/app/services/points.service';
import { NavaidModel } from 'src/app/models/navaid';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { Feature } from 'ol';
import View from 'ol/View';
import * as olExtent from 'ol/extent';
import {MapService} from 'src/app/services/map.service';
import {CoordinatePointModel} from 'src/app/models/coordinate-point';
import {ParentLayers} from "../../menu/view-menu/parent-layer";
import {EndpointsService} from "../../services/endpoints.service";
import {interval, Subscription, takeWhile} from "rxjs";

import {GritFeature} from "../../models/grit/grit.feature";
import {GritCondition, GritFilter} from "../../models/grit/grit.filter";
import {InterferenceTestModel} from "../../models/grit/grit.interference-test-model";
import {DeviceModel, InterferenceTestDeviceModel} from "../../models/grit/grit.device-model";
import {ReceiverModel} from "../../models/grit/grit.receiver-model";
import {GritProjectService} from "../../services/grit/grit.project.service";
import {RadarModel} from "../../models/grit/grit.radar-model";
import {GritInputCondition, GritOption} from "../../models/grit/grit.model";
import {GritDynamicTableMode, GritDynamicTableType} from "../../models/grit/grit.enums";
import {GritDynamicTableComponent} from "../../utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import {GritDynamicTableFeaturesComponent} from "../../utils/grit/grit-dynamic-table-features/grit-dynamic-table-features.component";


@Component({
  selector: 'app-map-search',
  templateUrl: './map-search.component.html',
  styleUrls: ['./map-search.component.scss'],
  standalone: false
})
export class MapSearchComponent implements OnInit, OnDestroy, DoCheck {

  coordPointsFields : string[] = Object.values(MapSearchCoordPointsFields) //["Id", "Name", "Type", "Latitude", "Longitude", "User Defined", "Max Altitude", "Min Altitude", "Nominal Altitude"];
  navaidsFields : string [] = Object.values(MapSearchNavAidsFields); //["Id", "Name", "Type","Latitude", "Longitude","Elevation", "DOC", "Max Altitude", "User Defined", "ICAO Country Code", "Channel"];
  fields : string[] = [];

  text_value : string = "";

  dropdown_options : string[] = [];
  allNavaids: NavaidModel[] = [];
  allCoordinatePoints: CoordinatePointModel[] = [];
  private previousActive = false;
  private authReadySubscription: Subscription;
  private dataSubscriptions: Subscription[] = [];

  constructor(
    protected mapSearchController : MapSearchService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,
    public pointService : PointsService,
    private globalSelectionService : GlobalSelectionControlService,
    private mapService : MapService,
    private endpointsService: EndpointsService
  ) {
   }
  ngDoCheck(): void {
    if (this.previousActive && !this.mapSearchController.active) {
          this.clearMapSearchState();
        }

    this.previousActive = this.mapSearchController.active;
  }

  ngOnInit(): void {
    this.fields = this.coordPointsFields;

    this.authReadySubscription = interval(100)
      .pipe(takeWhile(() => !this.endpointsService.httpOptions, true))
      .subscribe(() => {
        if (!this.endpointsService.httpOptions) {
          return;
        }

        this.authReadySubscription.unsubscribe();
        this.loadSearchData();
      });
  }

  private loadSearchData(): void {
    this.dataSubscriptions.push(this.pointService.getNavaids().subscribe(navaids => {
      this.allNavaids = navaids;
    }));
    this.dataSubscriptions.push(this.pointService.getCoordinatePoints().subscribe(points => {
      this.allCoordinatePoints = points as CoordinatePointModel[];
    }));
  }

    ngOnDestroy(): void {
    this.authReadySubscription?.unsubscribe();
    this.dataSubscriptions.forEach(subscription => subscription.unsubscribe());
    this.clearMapSearchState();
  }


  showFields(value : any){
    if(value == "Navaid"){
      this.fields = this.navaidsFields;
    }else {
      this.fields = this.coordPointsFields;
    }
  }

  applySearch(entity : any, field: any) {
    this.mapSearchController.coordinatePoints = [];
    this.mapSearchController.navaids = [];

    let converted_field_name = null;
    let value = this.text_value;

    if(entity == "Coordinate Point"){

      if(field == "Type"){
        value = getCoordinatePointTypesKeyByValue(this.text_value);
      }
      converted_field_name = getMapSearchCoordPointsFieldsKeyByValue(field);

    this.mapSearchController.coordinatePoints = this.allCoordinatePoints
      .filter(point =>
        point[converted_field_name] != null &&
        point[converted_field_name].toString().toLowerCase().startsWith(value.toLowerCase())
      )
      .filter(point => this.isCoordinatePointTypeVisible(point))
      .sort((a, b) => a.name.localeCompare(b.name));

    }else {
      converted_field_name = getMapSearchNavAidsFieldsKeyByValue(field);
      if(field == "Type"){
        value = getNavaidTypesKeyByValue(this.text_value);
      }

         this.mapSearchController.navaids = this.allNavaids
      .filter(navaid =>
        navaid[converted_field_name] != null &&
        navaid[converted_field_name].toString().toLowerCase().startsWith(value.toLowerCase())
      )
      .filter(navaid => this.isNavaidTypeVisible(navaid))
      .sort((a, b) => a.name.localeCompare(b.name));


    }

  }

  selectNavaidRow(navaid: NavaidModel) : void{
    const isSameNavaid =
    this.mapSearchController.previousSelectedNavaid?.id === navaid.id;

     if (isSameNavaid) {
      navaid.isselected = false;
      this.globalSelectionService.clearMapSearchHighlight();
      this.mapSearchController.previousSelectedNavaid = null;
       this.mapSearchController.previousSelectedNavaidFeature = null;
       return;
      }

    if (this.mapSearchController.previousSelectedNavaid) {
      this.mapSearchController.previousSelectedNavaid.isselected = false;
    }


    this.globalSelectionService.clearMapSearchHighlight();

    navaid.isselected = true;
    this.mapSearchController.previousSelectedNavaid = navaid;

    const highlightFeat = this.globalSelectionService.highlightNavaidLocation(navaid);
    if (!highlightFeat || !highlightFeat.getGeometry()) {
        return;
      }
    this.mapSearchController.previousSelectedNavaidFeature = highlightFeat;

    const map = this.mapService.getMap("map");
    const ext = highlightFeat.getGeometry().getExtent();

    const view = new View({
      projection: map.getView().getProjection(),
      center: olExtent.getCenter(ext),
    });

    view.fit(ext, { padding: [0, 0, 500, 0], maxZoom: 10 });
    map.setView(view);
  }

  selectCoordinatePointRow(point: CoordinatePointModel) : void{
    const isSameCoordinatePoint = this.mapSearchController.previousSelectedCoordinatePoint?.id === point.id;

    if (isSameCoordinatePoint) {
      point.isselected = false;
      this.globalSelectionService.clearMapSearchHighlight();

      this.mapSearchController.previousSelectedCoordinatePoint = null;
      this.mapSearchController.previousSelectedCoordinatePointFeature = null;
       return;
     }

    if(this.mapSearchController.previousSelectedCoordinatePoint){
      this.mapSearchController.previousSelectedCoordinatePoint.isselected = false;

    }
    this.globalSelectionService.clearMapSearchHighlight();

    point.isselected = true;
    this.mapSearchController.previousSelectedCoordinatePoint = point;
   const highlightFeat =this.globalSelectionService.highlightCoordinatePointLocation(point);

    if (!highlightFeat || !highlightFeat.getGeometry()) {
      return;
    }

    this.mapSearchController.previousSelectedCoordinatePointFeature = highlightFeat;

    let map = this.mapService.getMap("map");

    var ext=highlightFeat.getGeometry().getExtent();
    var center=olExtent.getCenter(ext);
    var view = new View({
      projection: map.getView().getProjection(),
      center: [center[0] , center[1]],//zoom to the center of your feature
    });
    view.fit(ext,{ padding : [0, 0, 500, 0], maxZoom: 10});
    //view.setZoom(10);
    view.set
    map.setView(view);
  }

  changeInputType(entity : string,field : string) {
    this.dropdown_options = [];
    this.text_value = "";
    switch(entity){
      case "Navaid":
        if (field == "Type"){
          this.dropdown_options = Object.values(NavaidTypes);
        }else {
          this.dropdown_options.push("true");
          this.dropdown_options.push("false");
        }
        break;
      case "Coordinate Point":
        if (field == "Type"){
          this.dropdown_options = Object.values(CoordinatePointTypes);
        }else {
          this.dropdown_options.push("true");
          this.dropdown_options.push("false");
        }
    }
  }
  private clearMapSearchState(): void {
    this.globalSelectionService.clearMapSearchHighlight();

    this.mapSearchController.previousSelectedNavaid = null;
    this.mapSearchController.previousSelectedNavaidFeature = null;
    this.mapSearchController.previousSelectedCoordinatePoint = null;
    this.mapSearchController.previousSelectedCoordinatePointFeature = null;

    this.mapSearchController.navaids?.forEach(n => n.isselected = false);
    this.mapSearchController.coordinatePoints?.forEach(p => p.isselected = false);

    this.allNavaids?.forEach(n => n.isselected = false);
    this.allCoordinatePoints?.forEach(p => p.isselected = false);
}


private isNavaidTypeVisible(navaid: NavaidModel): boolean {
  const layer = this.pointService.navaidsLayers.childLayers[0].layers
    .find(l => l.id === navaid.navaidtype.toLowerCase());

  return !!layer && layer.visible && layer.olLayer.getVisible();
}

private isCoordinatePointTypeVisible(point: CoordinatePointModel): boolean {
  const layerId = this.pointService.getLayerIdFromCoordPointType(point.type);

  const layer = this.pointService.coordinatePointsLayers.childLayers[0].layers
    .find(l => l.id === layerId);

  return !!layer && layer.visible && layer.olLayer.getVisible();
}


  //#region GRIT

  search = {
    options: [] as GritOption<GritInputCondition>[],
    values : [] as string[],
    layer: null as ParentLayers,
  }

  @ViewChild(GritDynamicTableFeaturesComponent) table : GritDynamicTableFeaturesComponent

  _searchDomain: string = "Navaid";
  get searchDomain() {return this._searchDomain}

  set searchDomain(domain: string){
    this._searchDomain = domain;

    this.setLayerFromDomain(domain);

    this.mapSearchController.gritSearched.elements = null;

    if (this.mapSearchController.gritSearched.selected != null) {
      this.globalSelectionService.removeSelectedFeature(this.mapSearchController.gritSearched.selected)
    }
    this.mapSearchController.gritSearched.selected = null;
    this.searchIndex = 0;
  }

  _searchIndex : number;

  get searchIndex(){return this._searchIndex}

  set searchIndex(i : number){
    this._searchIndex = i;
    this.search.values = [];
  }

  setLayerFromDomain(domain: string) {
    switch (domain) {
      case FeatureType.Device:
        this.search.options = InterferenceTestDeviceModel.configuration.search;
        this.search.layer = this.pointService.deviceLayer;
        break;
      case FeatureType.InterferenceTest:
        this.search.options = InterferenceTestModel.configuration.search;
        this.search.layer = this.pointService.interferenceTestLayer;
        break;
      case FeatureType.Radar:
        this.search.options = RadarModel.configuration.search;
        this.search.layer = this.pointService.radarLayer;
        break;
    }
  }

  getDisplay(array: GritOption<string>[], values: string[]){
    return values?.map(value => array.find(o => o.value === value.toString()).display ?? "");
  }

  gritApplySearch(){
    this.mapSearchController.gritSearched.elements = [];

    let filter = new GritFilter();
    let conditions: GritCondition[] = this.search.options[this.searchIndex]?.value.condition(this.search.values);
    filter.conditions.push(conditions)

    this.search.layer.childLayers.forEach(child => {
      child.showAll()
      child.layers.forEach(layer => {
        layer.olLayer.getSource().getFeatures().forEach((feature: GritFeature<any>) => {
          let model = feature.entity;
          if (filter.apply(model)) this.mapSearchController.gritSearched.elements.push(feature);
        })
      });
    });

    this.mapSearchController.gritSearched.elements.sort((a, b) => a.entity[conditions[0].field].toString().localeCompare(b.entity[conditions[0].field].toString()));
    this.table.features = this.mapSearchController.gritSearched.elements;
    this.mapSearchController.searchedProjection = this.mapService.getMap('map').getView().getProjection().getCode();
  }

  getGritFeatureFromSearchLayer(searchedFeature: GritFeature<any>) {
    for (const child of this.search.layer.childLayers) {
      for (const layer of child.layers) {
        for (const feature of layer.olLayer.getSource().getFeatures()) {
          const typedFeature = feature as GritFeature<any>;
          if (typedFeature.getId() == searchedFeature.getId()) {
            return typedFeature;
          }
        };
      };
    };
    return searchedFeature;
  }

  gritReprojectSearch() {
    this.setLayerFromDomain(this.searchDomain);
    this.mapSearchController.searchedProjection = this.mapService.getMap('map').getView().getProjection().getCode();
    for (let i = 0; i < this.mapSearchController.gritSearched.elements.length; i++) {
      const searchedFeature = this.mapSearchController.gritSearched.elements[i];
      this.mapSearchController.gritSearched.elements[i] = this.getGritFeatureFromSearchLayer(searchedFeature);
    }
    this.table.features = this.mapSearchController.gritSearched.elements;
  }

  gritSelectRow(feature: GritFeature<any>): void {
    if (this.mapSearchController.searchedProjection != this.mapService.getMap('map').getView().getProjection().getCode()) {
      this.gritReprojectSearch();
      feature = this.mapSearchController.gritSearched.elements.find(f => f.getId() == feature.getId());
    }
    let selected = this.mapSearchController.gritSearched.selected;
    if (selected != null) {
      this.globalSelectionService.removeSelectedFeature(selected)
      this.mapSearchController.gritSearched.selected = null;
      if (selected.getId() == feature.getId()) return;
    }
    this.mapSearchController.gritSearched.selected = feature;

    let layer: VectorLayerDMTR = this.search.layer.childLayers[0].layers.filter(layer  => layer.olLayer.getSource().hasFeature(feature))?.at(0).olLayer;

    //Style
    this.globalSelectionService.setSelectedFeature(layer, feature)

    //Focus
    let view = this.mapService.getMap("map").getView();
    let ext = feature.getGeometry().getExtent();
    let maxZoom = 20

    if (feature.featureType != FeatureType.InterferenceTest) {
      let center = olExtent.getCenter(ext);
      view.setCenter([center[0],center[1]])
      maxZoom = 7.5;
    }

    view.fit(ext, {padding: [0, 0, 500, 0], maxZoom: maxZoom});
  }

  //endregion

  protected readonly InterferenceTestModel = InterferenceTestModel;
  protected readonly GritProjectService = GritProjectService;
  protected readonly FeatureType = FeatureType;
  protected readonly GritDynamicTableMode = GritDynamicTableMode;
  protected readonly GritDynamicTableType = GritDynamicTableType;
}
